import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
// import { supabase } from "../client/client";

const NewNavbar = () => {
  const [openSearch, setOpenSearch] = useState(false);
  const [menuResp, setMenuResp] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  const menuResponsive = () => {
    setMenuResp(!menuResp);
  };

  const closeMenu = () => {
    setMenuResp(!menuResp);
  };

  return (
    <nav className="bg-primary w-full">
      <div className="mx-auto p-4">
        <div className="items-center"
        >
          <img src="/logo2.webp" className="w-[200px]" />
        </div>
      </div>
    </nav>
  );
};

export default NewNavbar;
